(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sample-request-form"] && !Shopify.designMode) return;
  try {
    
  class SampleRequestForm extends HTMLElement {
    connectedCallback() {
      this.onPhoneInput = this.onPhoneInput.bind(this);
      this.onCharInput = this.onCharInput.bind(this);
      this.onFormChange = this.onFormChange.bind(this);

      this.addEventListener('input', this.onFormChange);
      this.addEventListener('change', this.onFormChange);
      this.addEventListener('input', this.onDelegatedInput);
      this.addEventListener('blur', this.onDelegatedBlur, true);

      this.querySelectorAll('[data-char-count]').forEach((textarea) => {
        this.updateCounter(textarea);
      });

      this.updateSubmitState();
    }

    disconnectedCallback() {
      this.removeEventListener('input', this.onFormChange);
      this.removeEventListener('change', this.onFormChange);
      this.removeEventListener('input', this.onDelegatedInput);
      this.removeEventListener('blur', this.onDelegatedBlur, true);
    }

    onDelegatedInput(event) {
      if (event.target.matches('[data-phone-mask]')) this.onPhoneInput(event);
      if (event.target.matches('[data-char-count]')) this.onCharInput(event);
    }

    onDelegatedBlur(event) {
      if (event.target.matches('[data-phone-mask]')) this.onPhoneInput(event);
    }

    onPhoneInput(event) {
      const input = event.target;
      const digits = input.value.replace(/\D/g, '').slice(0, 11);
      let formatted = '';

      if (digits.length > 0) {
        formatted = '(' + digits.slice(0, 2);
      }

      if (digits.length >= 3) {
        const split = digits.length > 10 ? 7 : 6;
        formatted += ') ' + digits.slice(2, split);
        if (digits.length > 6) {
          formatted += '-' + digits.slice(split);
        }
      }

      input.value = formatted;
    }

    onCharInput(event) {
      this.updateCounter(event.target);
    }

    onFormChange() {
      this.updateSubmitState();
    }

    updateSubmitState() {
      const form = this.querySelector('form');
      const submitButton = this.querySelector('.sample-request-form__submit');
      if (!form || !submitButton) return;

      const requiredFields = form.querySelectorAll('input[required], textarea[required]');
      const radioNames = [];
      let isComplete = true;

      requiredFields.forEach((field) => {
        if (field.type === 'radio') {
          if (radioNames.indexOf(field.name) === -1) radioNames.push(field.name);
          return;
        }

        if (field.type === 'checkbox') {
          if (!field.checked) isComplete = false;
          return;
        }

        if (!field.value || field.value.trim() === '') isComplete = false;
      });

      radioNames.forEach((name) => {
        let hasChecked = false;
        requiredFields.forEach((field) => {
          if (field.type === 'radio' && field.name === name && field.checked) hasChecked = true;
        });
        if (!hasChecked) isComplete = false;
      });

      submitButton.disabled = !isComplete;
      if (isComplete) {
        submitButton.removeAttribute('aria-disabled');
      } else {
        submitButton.setAttribute('aria-disabled', 'true');
      }
    }

    updateCounter(textarea) {
      const wrap = textarea.closest('.sample-request-form__field-wrap');
      const counter = wrap ? wrap.querySelector('[data-counter]') : null;
      if (!counter) return;
      const max = textarea.maxLength;
      counter.textContent = textarea.value.length + ' / ' + max;
    }
  }

  if (!customElements.get('sample-request-form')) {
    customElements.define('sample-request-form', SampleRequestForm);
  }

  } catch(e) { console.error(e); }
})();
})();
